import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import PageTabs from '../../../components/PageTabs';
import { UsersThree, UserCircleCheck } from '@phosphor-icons/react';

const ManagerTeamTab = ({ children, darkMode }) => {
  const { slug } = useParams();
  const { user } = useAuth();
  const isServicesType = ['SERVICES', 'SALON'].includes(user?.businessType);

  const tabs = [
    { key: 'staff', label: 'Staff', icon: UsersThree, path: `/${slug}/manager/team` },
    ...(isServicesType ? [
      { key: 'attendants', label: 'Attendants', icon: UserCircleCheck, path: `/${slug}/manager/team/attendants` },
    ] : []),
  ];

  return (
    <>
      <PageTabs tabs={tabs} darkMode={darkMode} />
      {children}
    </>
  );
};

export default ManagerTeamTab;
